import React from 'react';

import { Button, Flex, Form, Input, Typography } from 'antd';

import { Link } from 'react-router-dom';
import { Routes } from 'routes';

import { useAuth } from 'features/auth/auth-action-sign-in-out';
import authSlice, { initialState } from 'features/auth/authSlice';
import { useReducer } from 'lib/hooks/useReducer';

import { theme } from 'styles/colors';
import { ConcussionRXLogo } from './concussionRx-logo';
import { ErrorMessage } from './ErrorMessage';
import './Signin.scss';
import { styles } from './styles';

/**
 * AntD link text component that works with react-router-dom
 * @param props
 * @returns
 */
export const LinkTextComponent: React.ComponentType<{
  navigate: () => void;
  href: string;
}> = props => (
  <Typography.Link
    {...props}
    onClick={event => {
      // Prevent the page from reloading
      event.preventDefault();
      props.navigate();
    }}
  />
);

export interface LoginFormProps {
  onSuccess?: () => void;
  onError?: () => void;
  actionItemLabel?: string;
  hideLogo?: boolean;
}

export function LoginForm(props: LoginFormProps) {
  const [{ error }, dispatch] = useReducer(authSlice, initialState); // isLoading, user,
  const auth = useAuth(dispatch);

  /**
   * WARN: `event` is cast to any and expects {email: string, password: string}
   * The login button onClick handler passes a React.FormEventHandler<HTMLElement>
   */
  const onSubmit = function (event: { email: string; password: string }) {
    auth.signIn.mutate(event, {
      onSuccess() {
        props.onSuccess?.();
      },
      onError() {
        props.onError?.();
      }
    });
  };

  return (
    // TODO: The parent needs to use flex so that this is positioned in the vertical center
    <Flex justify={'center'} align={'center'} flex={1}>
      <Form
        onFinish={onSubmit}
        name="login"
        initialValues={{
          remember: true
        }}
        className="login-form"
        style={styles.form}
        labelWrap={true}
        autoComplete="true"
      >
        {!props.hideLogo && (
          <Flex style={styles.titleContainer} justify="center">
            <ConcussionRXLogo />
          </Flex>
        )}

        {/* Email input */}
        <Form.Item
          name="email"
          rules={[
            {
              required: true,
              message: 'Please enter your email'
            },
            {
              type: 'email',
              message: 'Please enter a valid email'
            }
          ]}
        >
          <Input
            data-private="lipsum"
            placeholder="Email"
            className="account_form_item"
          />
        </Form.Item>

        {/* Password input */}
        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: 'Please input your Password!'
            }
          ]}
        >
          <Input.Password
            data-private="lipsum"
            type="password"
            placeholder="Password"
            className="account_form_item"
            visibilityToggle
          />
        </Form.Item>

        {error && <ErrorMessage errorMessage={error.message} />}

        {/* Forgot password */}
        <Flex>
          <Link
            to={{
              pathname: Routes.ForgotPassword
            }}
            className="login-form-forgot"
            style={{
              float: 'left',
              width: '100%',
              color: theme.secondary
            }}
            component={LinkTextComponent}
          >
            Forgot your password?
          </Link>
        </Flex>

        {/* Login button */}
        <Flex justify={'center'} style={{ marginTop: '3rem' }}>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
            style={styles.button}
          >
            {props.actionItemLabel ?? 'Login'}
          </Button>
        </Flex>
      </Form>
    </Flex>
  );
}
